// A grid's `1fr` track is `minmax(auto, 1fr)`: it never shrinks below its widest child's narrowest width, so
// one slider or long row inside a phone's single column widens the whole page sideways. The compiler writes
// every bare `fr` track the way the column-count form already does, `minmax(0, …fr)`, so the child scrolls
// inside its track instead. A track that already names its own minimum is left as the merchant wrote it.

/** A function opening, a closing bracket, or a flexible length: the three parts the walk reacts to. */
const TRACK_PART_RE = /([a-z-]+)\(|\)|(?<![\w.-])(\d*\.?\d+fr)\b/gi;

/** Functions whose `fr` already carries a minimum of its own. */
const SIZED_FUNCTIONS: ReadonlySet<string> = new Set(['minmax', 'fit-content']);

// Writes each bare `fr` track in a grid template as `minmax(0, …fr)`, so a wide child cannot widen the page.
export function shrinkableTracks(value: string): string {
  const open: string[] = [];
  return value.replace(TRACK_PART_RE, (part: string, name?: string, flex?: string) => {
    if (name) open.push(name.toLowerCase());
    else if (part === ')') open.pop();
    else if (flex && !open.some((fn) => SIZED_FUNCTIONS.has(fn))) return `minmax(0, ${flex})`;
    return part;
  });
}
